import { providePopulateData } from "components/utility/hoc/PopulateData";
import { connect } from "react-redux";
var moment = require("moment");

var WidgetConfig = require('lib/widgets/WidgetsConfig')
var WidgetItemsConfig = require('lib/widgets/WidgetItemsConfig')
var DataSelectors = require("lib/selectors/DataSelectors");
var DataActions = require("lib/actions/DataActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("data/data_table_summary");

function selectWidgetDigest(state, props) {
  var conditions = { period: 'yearly', entity_type: WidgetConfig.getEntityTypeByUserRole(props.admin.role) }
  if (props.studentListID) {
    conditions.entity_type = WidgetConfig.STUDENT_LIST_ENTITY_TYPE
    conditions.entity_id = props.studentListID
  }

  return _.first(DataSelectors.widgetDigests({ state, conditions }))
}

@connect(
  (state, props) => ({
    widgetDigest: selectWidgetDigest(state, props),
    studentList: RosterSelectors.studentList({ state, id: props.studentListID })
  }),
  (dispatch, props) => ({
    populateData: () => {
      var fetchPromises = []
      fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { adminID: props.admin.id } })))

      if (props.studentListID) {
        fetchPromises.push(dispatch(DataActions.fetchWidgetDigests({ conditions: { entityType: WidgetConfig.STUDENT_LIST_ENTITY_TYPE, adminID: props.admin.id } })))
      }

      return Promise.all(fetchPromises);
    }
  })
)

@providePopulateData()
class DataTableSummary extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }

  buildCard(metric) {
    var digest = this.props.widgetDigest
    if (!digest) { return null }
    
    var { lookup_key } = metric
    var config = WidgetItemsConfig.CONFIG['Admin']
    var widgetItemConfig = _.findWhere(config, { lookup_key: lookup_key })

    if (widgetItemConfig) {
      var { icon, title, primary_metric } = widgetItemConfig
      return (
        <div key={lookup_key} className={`summaryCard`}>
          <div className="cardContent">
            <div className='stat'>
              {Math.round(digest.data[primary_metric]) || 0}
            </div>
            <div className="iconContainer">
              <img className='iconImage' src={require(`widget-icons/${icon}-blue.png`)} />
              <div className='title'>
                {title}
              </div>
            </div>
          </div>
        </div>
      )
    }
  }

  renderHeader() {
    var { widgetDigest, studentList } = this.props
    if (!widgetDigest) { return null }

    if (widgetDigest.entity_type == WidgetConfig.STUDENT_LIST_ENTITY_TYPE && studentList) {
      var title = <strong>Data Summary for {studentList.name} ({moment(widgetDigest.start_date).format("M/YY")}-{moment(widgetDigest.end_date).format("M/YY")})</strong>
    } else {
      var title = <strong>All Student Data Summary ({moment(widgetDigest.start_date).format("M/YY")}-{moment(widgetDigest.end_date).format("M/YY")})</strong>
    }

    return (
      <div key={'date-cell'} className={`summaryDateCell`}>
        <div className='content'>
          {title}
        </div>
      </div>
    )
  }

  renderCards() {
    var metrics = SUMMARY_METRICS[this.props.subjectType]
    var cards = _.map(metrics, metric => { return this.buildCard(metric) })

    return (
      <span>
        {this.renderHeader()}
        <div className="summaryCardsContainer">
          {cards}
        </div>
      </span>
    )

  }

  render() {
    return (
      <div className="dataTableSummary hideOnPrint">
        {this.renderCards()}
      </div>
    );
  }
};

var QUIZ = 'quiz'
var BOOK = 'book'

var SUMMARY_METRICS = {
  [QUIZ]: [
    { lookup_key: WidgetItemsConfig.AVERAGE_LEXILE_LEVEL },
    { lookup_key: WidgetItemsConfig.YEARLY_TOTAL_QUIZZES, change: { status: null }},
    { lookup_key: WidgetItemsConfig.FAILED_QUIZZES, change: { status: 'failed' } },
    { lookup_key: WidgetItemsConfig.FLAGGED_QUIZZES, change: { status: 'flagged' } },
  ],
  [BOOK]: [
    { lookup_key: WidgetItemsConfig.AVERAGE_LEXILE_LEVEL },
    { lookup_key: WidgetItemsConfig.TOTAL_BOOKS},
    { lookup_key: WidgetItemsConfig.MINUTES_LOGGED},
  ]
}


DataTableSummary.propTypes = StrictPropTypes({
  subjectType: PropTypes.string,
  onClick: PropTypes.func,
  admin: PropTypes.object,
  studentListID: PropTypes.number,
});

module.exports = DataTableSummary;



// WEBPACK FOOTER //
// ./modules/components/data/subjects/shared/DataTableSummary.js